import { motion } from 'framer-motion';
import { Question } from '../types';
import { GlassCard } from './GlassCard';
import { ProgressBar } from './ProgressBar';

interface QuestionCardProps {
  question: Question;
  onAnswer: (index: number) => void;
  progress: number;
  questionNumber: number;
  totalQuestions: number;
  t: any;
}

export function QuestionCard({ 
  question, 
  onAnswer, 
  progress,
  questionNumber,
  totalQuestions,
  t
}: QuestionCardProps) {
  return (
    <GlassCard className="p-8 w-full max-w-2xl">
      <div className="mb-8">
        <ProgressBar progress={progress} />
        <div className="text-sm text-gray-400 text-right mt-2">
          {t.assessment.questionCount} {questionNumber} {t.assessment.of} {totalQuestions}
        </div>
      </div>
      <motion.div
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        exit={{ rotateY: -90 }}
        transition={{ duration: 0.5 }}
        className="w-full"
      >
        <h2 className="text-xl font-semibold mb-6 text-white">{question.question}</h2>
        <div className="space-y-4">
          {question.options.map((option, index) => (
            <motion.button
              key={index}
              onClick={() => onAnswer(index)}
              className="w-full p-4 text-left rounded-lg bg-white/5 hover:bg-white/10 transition-colors border border-white/10 text-gray-200"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {option}
            </motion.button>
          ))}
        </div>
      </motion.div>
    </GlassCard>
  );
}